import styled from "@emotion/styled";
import { Fonts } from "@snapchat/snap-design-system";

export const Paragraph = styled.div`
    ${Fonts.DeprecatedParagraph.P100}

    &:last-child {
        margin-top: 20px;
    }
`;
